import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import type { AppRoute } from '@/app/routes'
import { useAccessMap } from '@/hooks/use-access-map'
import { decidePageAccess } from '@/lib/page-access'

/** "Çok yakında" paneli (kapalı sayfa görünümü); sayfa içi kapılar (ör. Kai) aynı görünümü yeniden kullanır. */
export function ComingSoonPanel({ label }: { label: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-16 text-center" role="status">
      <h3 className="text-lg font-semibold text-foreground">{label}</h3>
      <p className="text-sm text-muted-foreground">Çok yakında</p>
    </div>
  )
}

/**
 * #825 dilim 3: sayfa kapısının tablo katmanı. RequireAdmin / RequirePro'nun İÇİNDE durur
 * (bugünkü kural önce işler); yalnız ek kısıtlama getirir. Harita gelene kadar çocuğu gösterir
 * (bugünkü davranış; yükleme iskeleti eklemek her sayfanın ilk açılışını yavaşlatırdı) — sunucu
 * uçları zaten kendi kapısını zorlar.
 */
export function RequirePageAccess({
  route,
  children,
}: {
  route: Pick<AppRoute, 'path' | 'label' | 'status' | 'externalUrl' | 'modalAction'>
  children: ReactNode
}) {
  const { data } = useAccessMap()
  const decision = decidePageAccess(data, route)

  if (decision === 'denied') return <Navigate to="/app/dashboard" replace />
  if (decision === 'coming_soon') {
    return <ComingSoonPanel label={route.label} />
  }
  return <>{children}</>
}
